import React from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { PopupInsideButton } from "../../buttonReusableComponent/ButtonReusableComponent";
import { DropDownButton } from "../../dropDownButtonReusable/DropDownButton";
import { ReusableOnboardingButton } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";

export const SeatingStatus = ({
  status,
  onOpenModal,
  open,
  onCloseModal,
  seatingStatus,
  onClickAll,
  onClickWalkin,
  onClickSeated,
  onClickNonSeated,
  onClickCancelled,
  onClickRejected,
  onClickCompleted,
  showText,
  showTextTwo,
  displayText,
  onStatusClick,
  displayHistory,
  displayNotSeatedButton,
  eventsMoreOptions,
}) => {
  try {
    return (
      <React.Fragment>
        <DropDownButton
          dropDownCss="main-dropdown-section d-flex  align-items-center"
          headingText={displayText === true ? "Order Type" : "Seating Status"}
          divClass="insidedropdown-div"
          insideText={status}
          displayDropDown=""
          onClick={onOpenModal}
        />
        <Modal
          open={open}
          onClose={onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "small-popup",
            closeButton: "customCloseButton",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div className="reusable-popup-header-newstyle">
            <h4 className="c-black font_24_b">Seating Status</h4>
          </div>
          <div className="">
            <div className="f16-500 mt-5 mb-5">
              Select one relevant option from below
            </div>
            <div className="d-flex flex-wrap ">
              <PopupInsideButton
                buttonClass={
                  seatingStatus === "All"
                    ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                    : "status-selected-button-box f18-500"
                }
                buttonText="All"
                buttonType="button"
                onClick={onClickAll}
              />
              {showTextTwo === "history" ? (
                <PopupInsideButton
                  buttonClass={
                    seatingStatus === "Not Seated" || seatingStatus === "Walkin"
                      ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                      : "status-selected-button-box f18-500"
                  }
                  buttonText={showText === "pending" ? "Walkin" : ""}
                  buttonType="button"
                  onClick={onClickWalkin}
                />
              ) : null}
              <PopupInsideButton
                buttonClass={
                  seatingStatus === "Seated" || seatingStatus === "Waitlist"
                    ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                    : "status-selected-button-box f18-500"
                }
                buttonText={showText === "pending" ? "Waitlist" : "Seated"}
                buttonType="button"
                onClick={onClickSeated}
              />
              {!displayNotSeatedButton && (
                <PopupInsideButton
                  buttonClass={
                    seatingStatus === "Not Seated" ||
                    seatingStatus === "Reservation"
                      ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                      : "status-selected-button-box f18-500"
                  }
                  buttonText={
                    showText === "pending" ? "Reservation" : "Not Seated"
                  }
                  buttonType="button"
                  onClick={onClickNonSeated}
                />
              )}
              {displayHistory === true ? (
                <React.Fragment>
                  <PopupInsideButton
                    buttonClass={
                      seatingStatus === "Cancelled"
                        ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                        : "status-selected-button-box f18-500"
                    }
                    buttonText={"Cancelled"}
                    buttonType="button"
                    onClick={onClickCancelled}
                  />
                  <PopupInsideButton
                    buttonClass={
                      seatingStatus === "Rejected"
                        ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                        : "status-selected-button-box f18-500"
                    }
                    buttonText={"Rejected"}
                    buttonType="button"
                    onClick={onClickRejected}
                  />
                  <PopupInsideButton
                    buttonClass={
                      seatingStatus === "Completed"
                        ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                        : "status-selected-button-box f18-500"
                    }
                    buttonText={"Completed"}
                    buttonType="button"
                    onClick={onClickCompleted}
                  />
                </React.Fragment>
              ) : null}
              <PopupInsideButton
                buttonClass={
                  seatingStatus === "Not Seated" ||
                  seatingStatus === "Reservation"
                    ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                    : "status-selected-button-box f18-500"
                }
                buttonText={
                  showText === "pending" ? "Reservation" : "Not Seated"
                }
                buttonType="button"
                onClick={onClickNonSeated}
              />
            </div>
            {eventsMoreOptions && (
              <div className="d-flex justify-content-between">
                <PopupInsideButton
                  buttonClass={
                    seatingStatus === "All"
                      ? "status-selected-button-box font_20_m sts_sld_btn_box_a"
                      : "status-selected-button-box font_20_m"
                  }
                  buttonText="Cancelled"
                  buttonType="button"
                  // onClick={onClickAll}
                />
                <PopupInsideButton
                  buttonClass={
                    seatingStatus === "All"
                      ? "status-selected-button-box font_20_m sts_sld_btn_box_a"
                      : "status-selected-button-box font_20_m"
                  }
                  buttonText="Completed"
                  buttonType="button"
                  // onClick={onClickAll}
                />
                <PopupInsideButton
                  buttonClass={
                    seatingStatus === "All"
                      ? "status-selected-button-box font_20_m sts_sld_btn_box_a"
                      : "status-selected-button-box font_20_m"
                  }
                  buttonText="Rejected"
                  buttonType="button"
                  // onClick={onClickAll}
                />
              </div>
            )}
            <div className="mt-5 d-flex">
              <ReusableOnboardingButton
                buttonTitle="Cancel Button"
                buttonClass={
                  "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                }
                buttonText="Cancel"
                onClick={onCloseModal}
                buttonType="button"
              />
              <ReusableOnboardingButton
                buttonTitle="Confirm Button"
                buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                buttonText="Confirm"
                onClick={onStatusClick}
                buttonType="button"
              />
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  } catch (e) {
    console.log(e);
  }
};

export const SeatingStatusTwo = ({
  status,
  onOpenModal,
  open,
  onCloseModal,
  seatingStatus,
  onClickAll,
  onClickSeated,
  onClickCompleted,
  onClickRejected,
  onClickCancelled,
}) => {
  return (
    <React.Fragment>
      <DropDownButton
        dropDownCss="main-dropdown-section"
        headingText="Seating Status"
        divClass="inside-div"
        insideText={status}
        displayDropDown=""
        onClick={onOpenModal}
      />
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "customOverlay-request-accept-cancelled",
          modal: "small-popup",
          closeButton: "customCloseButton",
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
        }}
        animationDuration={1000}
      >
        <div className="reusble-popup-header-style">
          <h4>Seating Status</h4>
        </div>
        <div className="reason-for-cancellation edit-wait-time">
          <div className="">
            <PopupInsideButton
              buttonClass={
                seatingStatus === "All"
                  ? "popup-inside-button popup-inside-buttonactive"
                  : "popup-inside-button"
              }
              buttonText="All"
              buttonType="button"
              onClick={onClickAll}
            />
            <PopupInsideButton
              buttonClass={
                seatingStatus === "Seated"
                  ? "popup-inside-button popup-inside-buttonactive"
                  : "popup-inside-button"
              }
              buttonText="Seated"
              buttonType="button"
              onClick={onClickSeated}
            />
            <PopupInsideButton
              buttonClass={
                seatingStatus === "Completed"
                  ? "popup-inside-button popup-inside-buttonactive"
                  : "popup-inside-button"
              }
              buttonText="Completed"
              buttonType="button"
              onClick={onClickCompleted}
            />
            <PopupInsideButton
              buttonClass={
                seatingStatus === "Rejected"
                  ? "popup-inside-button popup-inside-buttonactive"
                  : "popup-inside-button"
              }
              buttonText="Rejected"
              buttonType="button"
              onClick={onClickRejected}
            />
            <PopupInsideButton
              buttonClass={
                seatingStatus === "Cancelled"
                  ? "popup-inside-button popup-inside-buttonactive"
                  : "popup-inside-button"
              }
              buttonText="Cancelled"
              buttonType="button"
              onClick={onClickCancelled}
            />
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export const OrderStatusPopupModal = ({
  status,
  onOpenModal,
  open,
  onCloseModal,
  seatingStatus,
  onClickAll,
  onClickPending,
  onClickConfirmed,
  onClickPreparing,
  onClickPacking,
  onClickReadyToPick,
  onClickOnTheWay,
  onClickDelivered,
  onClickCompleted,
  onClickCancelled,
}) => {
  return (
    <React.Fragment>
      <DropDownButton
        dropDownCss="main-dropdown-section d-flex align-items-center"
        headingText="Ordering Status"
        divClass="insidedropdown-div"
        insideText={status}
        displayDropDown=""
        onClick={onOpenModal}
      />
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "customOverlay-request-accept-cancelled",
          modal: "small-popup",
          closeButton: "customCloseButton",
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
        }}
        animationDuration={1000}
      >
        <div className="reusable-popup-header-newstyle">
          <h4 className="c-black font_24_b">Ordering Status</h4>
        </div>
        <div className="mt-3">
          <div className="d-flex flex-wrap ">
            <PopupInsideButton
              buttonClass={
                seatingStatus === "All"
                  ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                  : "status-selected-button-box f18-500"
              }
              buttonText="All"
              buttonType="button"
              onClick={onClickAll}
            />
            <PopupInsideButton
              buttonClass={
                seatingStatus === "Pending"
                  ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                  : "status-selected-button-box f18-500"
              }
              buttonText="Pending"
              buttonType="button"
              onClick={onClickPending}
            />
            <PopupInsideButton
              buttonClass={
                seatingStatus === "Confirmed"
                  ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                  : "status-selected-button-box f18-500"
              }
              buttonText="Confirmed"
              buttonType="button"
              onClick={onClickConfirmed}
            />
            <PopupInsideButton
              buttonClass={
                seatingStatus === "Preparing"
                  ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                  : "status-selected-button-box f18-500"
              }
              buttonText="Preparing"
              buttonType="button"
              onClick={onClickPreparing}
            />
            <PopupInsideButton
              buttonClass={
                seatingStatus === "Packing"
                  ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                  : "status-selected-button-box f18-500"
              }
              buttonText="Packing"
              buttonType="button"
              onClick={onClickPacking}
            />
            <PopupInsideButton
              buttonClass={
                seatingStatus === "Ready To Pick"
                  ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                  : "status-selected-button-box f18-500"
              }
              buttonText="Ready To Pick"
              buttonType="button"
              onClick={onClickReadyToPick}
            />
            <PopupInsideButton
              buttonClass={
                seatingStatus === "On The Way"
                  ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                  : "status-selected-button-box f18-500"
              }
              buttonText="On The Way"
              buttonType="button"
              onClick={onClickOnTheWay}
            />
            <PopupInsideButton
              buttonClass={
                seatingStatus === "Delivered"
                  ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                  : "status-selected-button-box f18-500"
              }
              buttonText="Delivered"
              buttonType="button"
              onClick={onClickDelivered}
            />
            <PopupInsideButton
              buttonClass={
                seatingStatus === "Completed"
                  ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                  : "status-selected-button-box f18-500"
              }
              buttonText="Completed"
              buttonType="button"
              onClick={onClickCompleted}
            />
            <PopupInsideButton
              buttonClass={
                seatingStatus === "Cancelled"
                  ? "status-selected-button-box f18-500 sts_sld_btn_box_a"
                  : "status-selected-button-box f18-500"
              }
              buttonText="Cancelled"
              buttonType="button"
              onClick={onClickCancelled}
            />
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};
